/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Position,
    PositionFromJSON,
    PositionFromJSONTyped,
    PositionToJSON,
    Stream,
    StreamFromJSON,
    StreamFromJSONTyped,
    StreamToJSON,
} from './';

/**
 * 
 * @export
 * @interface DataOutage2gEventInterval
 */
export interface DataOutage2gEventInterval {
    /**
     * 
     * @type {string}
     * @memberof DataOutage2gEventInterval
     */
    monitoredObjectId: string;
    /**
     * 
     * @type {number}
     * @memberof DataOutage2gEventInterval
     */
    clientId: number;
    /**
     * 
     * @type {Position}
     * @memberof DataOutage2gEventInterval
     */
    positionStart?: Position;
    /**
     * 
     * @type {Position}
     * @memberof DataOutage2gEventInterval
     */
    positionEnd?: Position;
    /**
     * 
     * @type {Date}
     * @memberof DataOutage2gEventInterval
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof DataOutage2gEventInterval
     */
    end?: Date;
    /**
     * 
     * @type {string}
     * @memberof DataOutage2gEventInterval
     */
    eventId?: string;
    /**
     * 
     * @type {Stream}
     * @memberof DataOutage2gEventInterval
     */
    stream?: Stream;
    /**
     * 
     * @type {string}
     * @memberof DataOutage2gEventInterval
     */
    type?: DataOutage2gEventIntervalTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataOutage2gEventInterval
     */
    country: string;
}

export function DataOutage2gEventIntervalFromJSON(json: any): DataOutage2gEventInterval {
    return DataOutage2gEventIntervalFromJSONTyped(json, false);
}

export function DataOutage2gEventIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataOutage2gEventInterval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': json['monitored_object_id'],
        'clientId': json['client_id'],
        'positionStart': !exists(json, 'position_start') ? undefined : PositionFromJSON(json['position_start']),
        'positionEnd': !exists(json, 'position_end') ? undefined : PositionFromJSON(json['position_end']),
        'start': (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'eventId': !exists(json, 'event_id') ? undefined : json['event_id'],
        'stream': !exists(json, 'stream') ? undefined : StreamFromJSON(json['stream']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'country': json['country'],
    };
}

export function DataOutage2gEventIntervalToJSON(value?: DataOutage2gEventInterval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_id': value.monitoredObjectId,
        'client_id': value.clientId,
        'position_start': PositionToJSON(value.positionStart),
        'position_end': PositionToJSON(value.positionEnd),
        'start': (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'event_id': value.eventId,
        'stream': StreamToJSON(value.stream),
        'type': value.type,
        'country': value.country,
    };
}

/**
* @export
* @enum {string}
*/
export enum DataOutage2gEventIntervalTypeEnum {
    DataOutage2g = 'data_outage_2g'
}


